<template>
  <div class="page-ilava">
    <div class="container pt-4 pb-5" style="max-width: 830px;">
      
      <div class="pt-5">

        <div class="c text-center pt-1">
          <h1 v-if="$store.state.app.lang === 'en'"  style="font-size: 4em;">
            {{lg('',{
              en: 'JGN Diamond',
              zh: '',
            })}}
          </h1>
        </div>

        <div 
          class="bg-c text-white text-center py-3"
          style="font-size: 4em;"
          >
          <h1 class="mb-0">
            {{lg('',{
              en: 'JGN Plan',
              zh: 'JGN钻石俱乐部',
            })}}
          </h1>
        </div>
      </div>

      <div class="my-4 text-center">
        <p>
          {{lg('',{
            en: 'We are all in this together.',
            zh: '您好，欢迎加入JGN钻石俱乐部！',
          })}}
          <br>
          {{lg('',{
            en: 'JGN Diamond offers our unique DeFi blend of decentralized ownership and community growth. By combining Staking rewards, DAO decision making and other members only features, we aim to attain a thriving and autonomous decentralized future together.',
            zh: 'JGN钻石俱乐部经过全面的DeFi升级及生态创新，为JGN会员提供了全新的会员权益和生态利益，极大的推动了平台会员归属权及社区生态的快速成长。加入JGN钻石俱乐部，拥有dJGN (独特的会员凭证)，可享受DAO池专属的平台决策机制、实时质押奖励及各种生态福利，让JGN长期持有用户拥有更好的决策权、全新的体验感及丰富的生态利益。',
          })}}
          
        </p>
      </div>

      <div class="row mt-5">

        <div class="col-md-5 mb-4">
          <div 
            class="ui-card-b text-center p-4" 
            style="min-height: 320px;height: 100%;"
            >
            <div class="mx-auto mt-4" style="width: 150px; height: 150px;">
              <img 
                src="/static/img/icon_diamond_logo.png"
                style="max-width:100%;"
              >
            </div>
            <div>
              <h5 class="mt-4">
                {{lg('',{
                  en: 'Your Real-Time APY',
                  zh: '实时APY',
                })}}
              </h5>
              <div 
                class="c b i pt-4" 
                style="font-size: 28px;margin-left: -8px;font-family: vertana;"
                >
                {{res_num_apy | bfh}}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-7 mb-4">

          <div 
            class="ui-card-b text-center p-4"
            style="min-height: 140px;"
            >
            <div 
              class="sp-num-member"
              v-html="calcHtmlForNumMember(res_num_membership)"
              >
            </div>
            <div class="mt-3">
              {{lg('',{
                en: 'People have already become Diamond members',
                zh: '目前钻石会员数目',
              })}}
            </div>
          </div>

          <div class="row" style="margin-top: 30px;height: 180px;">
            <div class="col-6">

              <!-- block -->
              <div class="ui-card-b bg-c text-dark" style="height: 100%;">
                
                <div class="mx-auto mt-4 text-center" style="width: 70px; height: 70px;">
                  <img 
                    src="/static/img/icon_diamond_logo_dark.png"
                    style="max-width:100%;"
                  >
                </div>

                <div class="text-center">
                  <h2 class="mb-0">
                    {{ res_num_ilava_balance | tofixed4 | qfw}}
                  </h2>
                  <div>
                    {{lg('',{
                      en: 'My dJGN',
                      zh: '实时dJGN数目',
                    })}}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">

              <!-- block -->
              <div class="ui-card-b" style="height: 100%;">
                
                <div class="mx-auto mt-4 text-center" style="width: 70px; height: 70px;">
                  <img 
                    src="/static/img/icon_diamond_logo_reward.png"
                    style="max-width:100%;"
                  >
                </div>

                <div class="text-center">
                  <h2 class="mb-0">
                    {{ res_num_ilava_reward | tofixed4 | qfw}}
                  </h2>
                  <div>
                    {{lg('',{
                      en: 'Membership Rewards',
                      zh: '会员奖励',
                    })}}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <div class="row">
          <div class="col-md-6 mb-4">
            <!-- btns -->
            <button 
              @click="toggleRiskTip(); on_modal_tab = 'mint'"
              class="btn btn-primary btn-lg pl-4 pr-5"
              style="width: 250px;"
              >
              {{lg('',{
                en: 'Mint dJGN',
                zh: '铸造dJGN',
              })}}
            </button>

            <button 
              @click="toggleRiskTip(); on_modal_tab = 'mint'"
              class="btn btn-primary btn-lg mx-2 text-center"
              style="width: 50px;"
              >
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>

          <div class="col-md-6 mb-4 text-right">

            <button 
              @click="toggleRiskTip(); on_modal_tab = 'redeem'"
              class="btn bg-white btn-lg mx-2 text-center"
              style="width: 50px;"
              >
              <span class="text-dark">
                <i class="fas fa-chevron-left"></i>
              </span>
            </button>

            <button 
              @click="toggleRiskTip(); on_modal_tab = 'redeem'"
              class="btn bg-white btn-lg pl-4 pr-5"
              style="width: 250px;"
              >
              <span class="text-dark">
                {{lg('',{
                  en: 'Redeem JGN',
                  zh: '赎回JGN',
                })}}
              </span>
            </button>
          </div>
        </div>
      </div>

      <div v-if="0" class="my-4 text-center">
        <router-link 
          class="btn btn-primary btn-lg"
          :to="{name: 'airdrop'}"
          >
          {{lg('',{
            en: 'Airdrop Claim Center',
            zh: '',
          })}}
          <i class="far fa-arrow-alt-circle-right ml-2"></i>
        </router-link>
      </div>

      <!-- 统计 -->
      <div class="mt-5 ui-card-b mx-auto" style="border-color: #fff;width: 450px; max-width: 100%;">
        <h3 class="bg-white text-center py-2" style="margin: -1px;">
          {{lg('',{
            en: 'DIAMOND JGN STATS',
            zh: 'JGN钻石会员数据',
          })}}
        </h3>
        <div class="py-4 px-5 text-center" style="line-height: 20px;">
          <div class="bg-c text-dark py-2 px-3 mb-3" style="border-radius: 8px;">
            <span class="d-block">
              {{lg('',{
                en: 'Number of JGN Stakes',
                zh: '总质押的JGN数目',
              })}}
            </span>
            <h3 class="ml-auto d-block mb-0">
              {{res_num_ilava_total_supply*100?res_num_ilava_total_supply*100:'-' | tofixed2 | qfw }}
            </h3>
          </div>
          <div class="bg-c text-dark py-2 px-3 mb-3" style="border-radius: 8px;">
            <span class="d-block">
              {{lg('',{
                en: 'dJGN Minted',
                zh: '一共铸造的dJGN数目',
              })}}
            </span>
            <h3 class="ml-auto d-block mb-0">
              {{res_num_ilava_total_supply | tofixed2 | qfw }}
            </h3>
          </div>
          <div class="bg-c text-dark py-2 px-3 mb-3" style="border-radius: 8px;">
            <span class="d-block">
              {{lg('',{
                en: 'Current Exit Fee Rate',
                zh: '退会费用',
              })}}
            </span>
            <h3 class="ml-auto d-block mb-0">
              5%
            </h3>
          </div>
          <div class="bg-c text-dark py-2 px-3" style="border-radius: 8px;">
            <span class="d-block">
              {{lg('',{
                en: 'Exit membership fee income (in dJGN)',
                zh: '退会累计费用 (dJGN)',
              })}}
            </span>
            <h3 class="ml-auto mb-0">
              {{res_num_ilava_income | tofixed2 | qfw }}
            </h3>
          </div>
        </div>
      </div>

      <UiModal
        :open="status_show_modal"
        class="modal-ilava-sp"
        @close="toggleModal()"
        >
        <div class="px-4 pb-4 pt-3">
          <div class="ui-tabset-style2 border-bottom b" style="font-size: 16px;">
            <span 
              @click="on_modal_tab = 'mint'"
              :class="['tab',{'on': on_modal_tab === 'mint'}]"
              >
              {{lg('',{
                en: 'Mint',
                zh: '铸造',
              })}}
            </span>
            <span 
              @click="on_modal_tab = 'redeem'"
              :class="['tab',{'on': on_modal_tab === 'redeem'}]"
              >
              {{lg('',{
                en: 'Redeem ',
                zh: '赎回',
              })}}
            </span>
          </div>

          <formMint
            v-if="on_modal_tab === 'mint'"
          />
          <formRedeem
            v-if="on_modal_tab === 'redeem'"
          />

        </div>
      </UiModal>

      <UiModal
        :open="status_show_risk_tip"
        class="modal-risk-tip-sp"
        @close="status_show_risk_tip = false"
      >
        <div class="pt-4 pb-5 px-4">

          <h5 class="py-1 text-muted text-center">
            {{lg('',{
              en: 'Risk Disclaimer',
              zh: '风险提示',
            })}}
          </h5>
          <!-- tips -->
          <div 
            class="border p-3 small" 
            style="max-height: 200px; overflow: auto; line-height: 22px;background: rgba(0,0,0,0.3);border-radius: 5px;"
            >
            <div class="mb-1">
              {{lg('',{
                en: 'You have to pay an exit fee when you redeem dJGN tokens back to JGN. This exit fee will be distributed to all remaining dJGN holders.',
                zh: '当您将dJGN代币赎回成JGN时，您需要缴纳一笔退会费。这笔退会费，会以 dJGN 的形式，即时分配给未退出的所有dJGN 持有者。',
              })}}
            </div>

            <!-- <div class="mb-1">
              {{lg('',{
                en: '2. You will be entering the wallet address of your referrer, who will receive rewards for inviting you to mint iLAVA. Please ensure that the address entered is correct, because you will not be able to change it.',
                zh: '2. 当您输入推荐人的钱包地址后，推荐人将因邀请您铸造iLAVA而获得奖励。地址输入后无法更改，请确保输入的地址是正确的。',
              })}}
            </div>

            <div class="mb-1">
              {{lg('',{
                en: '3. Your referrer must already hold iLAVA to be eligible.',
                zh: '3. 您的推荐人必须已经持有iLAVA才拥有推荐资格。',
              })}}
            </div> -->
          </div>
          <div class="mt-3">
            <label class="small usn" style="line-height: 22px;">
              <input 
                v-model="status_checked_risk_tip"
                type="checkbox" 
                class="mr-2"
              >
              {{lg('',{
                en: 'I have read, understand, and agree to the Terms of Service.',
                zh: '我确认我已阅读、理解并同意用户使用协议。',
              })}}
            </label>

            <button 
              :disabled="!status_checked_risk_tip" 
              class="btn btn-primary w-100 btn-lg mt-4"
              @click="toggleModal(true)"
              >
              {{lg('',{
                en: 'Continue',
                zh: '继续',
              })}}
            </button>
          </div>
        </div>
      </UiModal>

    </div>
  </div>
</template>

<script>

import {mapActions} from 'vuex'

import formMint from './form_mint.vue'
import formRedeem from './form_redeem.vue'

export default {
  name: 'ilava',
  components: {
    formMint,
    formRedeem,
  },
  props: [],
  data() {
    return {
      status_show_risk_tip: false,
      status_checked_risk_tip: false,


      status_show_modal: false,
      on_modal_tab: 'mint',

      res_num_apy: '-',
      res_num_membership: '----',

      res_num_ilava_balance: '-',
      res_num_ilava_reward: '-',

      res_num_ilava_total_supply: '-',
      res_num_ilava_income: '-',
    }
  },
  computed: {},
  watch: {
    'v.$store.state.web3.account'(val){
      if(val){
        this.run()
      }
    }
  },
  methods: {

    ...mapActions([
      'iLAVA_getAPY',
      'iLAVA_getMembers',
      'iLAVA_getiLavaBalance',
      'iLAVA_getILAVAReward',
      'iLAVA_getiLavaTotalSupply',
      'iLAVA_getReemTotal',
    ]),

    // 加样式
    calcHtmlForNumMember(num){
      let temp = (num + '').trim()
      let arr = temp.split('')
      let html = ''
      arr.forEach(char => {
        html += `<span class="bg-c text-white b c-border-sp">${char}</span>`
      })
      return html
    },

    // 风险提示
    toggleRiskTip(val){
      if( (val || !this.status_show_modal) && this.status_checked_risk_tip){
        this.toggleModal(true)
        return
      }
      this.status_show_risk_tip = (val !== undefined ? val : !this.status_show_risk_tip)
    },

    // 主操作form
    toggleModal(val){
      this.status_show_risk_tip = false
      this.status_show_modal = (val !== undefined ? val : !this.status_show_modal)
    },
    async run(){
      let v = this
      
      let address_my  = v.$store.state.web3.account

      let res_num_apy_fn = v.iLAVA_getAPY()
      let res_num_membership_fn = v.iLAVA_getMembers()
      let res_num_ilava_balance_fn,res_num_ilava_reward_fn
      if(address_my){
        res_num_ilava_balance_fn = v.iLAVA_getiLavaBalance({address: address_my})
        res_num_ilava_reward_fn = v.iLAVA_getILAVAReward({address: address_my})
      }
      let res_num_ilava_total_supply_fn = v.iLAVA_getiLavaTotalSupply()
      let res_num_ilava_income_fn = v.iLAVA_getReemTotal()
      
      v.res_num_apy = await res_num_apy_fn
      v.res_num_membership = ((await res_num_membership_fn) + '').padStart(4,'0')

      
      if(address_my){
        v.res_num_ilava_balance = await res_num_ilava_balance_fn
        v.res_num_ilava_reward = await res_num_ilava_reward_fn
      }

      v.res_num_ilava_total_supply = await res_num_ilava_total_supply_fn
      v.res_num_ilava_income = await res_num_ilava_income_fn
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss">
  .page-ilava{

    .bg-sp{
      background-color: #222;
      color: #eee;
    }
    .bg-sp2{
      background-color: #303030;
      color: #eee;
    }
    .c-border-sp{
      border: 1px solid #444;
    }
    .radius-sp{
      border-radius: 40px;
    }
    .sp-num-member{
      span{
        display: inline-block;
        margin: 0 15px;
        width: 45px;
        height: 55px;
        line-height: 55px;
        font-size: 27px;
        font-weight: bold;
        border-radius: 4px;
        font-size: 38px;
        text-shadow: 1px 2px rgba(0,0,0,0.1);


        text-align: center;
      }
    }

    .icon-sp{
      display: inline-block;
      width: 40px;
      height: 40px;
      text-align: center;
      img{
        max-height: 100%;
      }
    }

    .modal-ilava-sp{
      .shell{
        background-color: #222 !important;
        color: #eee !important;

        .iconclose{
          color: #fff;
        }
      }
    }

    .modal-risk-tip-sp{
      ::-webkit-scrollbar{
        width: 10px;
        &-thumb{
          color: #333;
        }
      }
      .shell{
        max-width: 350px;
        background-color: #222 !important;
        color: #eee !important;

        .iconclose{
          color: #fff;
        }
      }
    }

    input.sp-transparent{
      appearance: none;
      border: none;
      background-color: transparent;
      text-align: right;
      font-size: 26px;
      color: #fff;
      padding-right: 10px;
    }
  }
</style>